export default {
  items: [
    {
      id: "navigation",
      title: "Navigation",
      type: "group",
      icon: "icon-navigation",
      children: [
        {
          id: "home",
          title: "Inicio",
          type: "item",
          icon: "feather icon-home",
          url: "/",
        },
        {
          id: "admin",
          title: "Administración",
          type: "collapse",
          icon: "feather icon-lock",
          children: [
            {
              id: "general",
              title: "General",
              type: "item",
              url: "/administracion/general",
            },
            {
              id: "season",
              title: "Temporada Alta",
              type: "item",
              url: "/administracion/temporada-alta",
            },
            {
              id: "centers",
              title: "Centros de Recreación",
              type: "item",
              url: "/administracion/centros-de-recreacion",
            },
            {
              id: "users",
              title: "Usuarios",
              type: "item",
              url: "/administracion/usuarios",
            },
            {
              id: "reports",
              title: "Reportes",
              type: "item",
              url: "/administracion/reportes",
            },
            {
              id: 'requests',
              title: 'Solicitudes',
              type: 'item',
              url: '/administracion/solicitudes'
          }
          ],
        },
      ],
    },
  ],
};
